export default {
      id: "i-find-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/sprite.svg#i-find",
      toString: function () {
        return this.url;
      }
    }